import { createFileRoute } from "@tanstack/react-router";
import { PeoplePage } from "@/features/people/people-page";

export const Route = createFileRoute("/app/w/$weddingId/people")({ component: PeoplePage });
